import React from 'react';
import { Avatar, Typography } from '@mui/material';
import { Person4 as ManFaceIcon, Person3 as WomanFaceIcon } from '@mui/icons-material';
import { StyledListItem, StyledListItemAvatar, StyledListItemText } from '../styles';
var CustomerListItemName = function (_a) {
    var firstName = _a.firstName, gender = _a.gender, lastName = _a.lastName;
    return (React.createElement(StyledListItem, null,
        React.createElement(StyledListItemAvatar, null,
            React.createElement(Avatar, null, gender === 'F' ? React.createElement(WomanFaceIcon, null) : React.createElement(ManFaceIcon, null))),
        React.createElement(StyledListItemText, { primary: React.createElement(Typography, { color: !firstName ? 'text.secondary' : 'text.primary' }, firstName || 'Missing'), secondary: React.createElement(Typography, { color: !lastName ? 'text.secondary' : 'text.primary' }, lastName || 'Missing') })));
};
export default CustomerListItemName;
//# sourceMappingURL=CustomerListItemName.js.map